import Vue from 'vue';
import { mapState } from 'vuex';
import * as api from '../services/api';
import Select2 from '../../components/shared/select2';
import * as blockui from '../../helpers/block-ui';

export default {
  props: ['procedure', 'isUpdate', 'isChild'],
  data() {
    return {
      selectedProcedure: {},
      procedureTypeList: [],
      file: {},
      maxFileSize: 20,
      fileTypeList: [],
      acceptedExtensions: [],
    };
  },
  components: {
    select2: Select2,
  },
  async mounted() {
    window.$('form').validate();
    const self = this; let
      table;

    await self.init();

    $('#procedure_modal').on('hidden.bs.modal', (e) => {
      self.$emit('close');
    });

    api.getFileTypeList().then((response) => {
      self.fileTypeList = response.body; //self.fileTypeList = response.body.Data;
      self.fileTypeList.forEach((fileType) => {
        self.acceptedExtensions.push(fileType.Extension);
      });
    });

    api.getFormStatuses().then((res) => {
      self.formStatusList = res.body;
    });

    api.getProcedureTypes().then((res) => {
      self.procedureTypeList = res.body;
    });

    this.$nextTick(() => {
      Vue.loadAsteriks();
    });
  },
  methods: {
    async init() {
      /*      blockui.blockModal(this);
            let promises = [
              this.$store.dispatch('getCapacityEquipmentList'),
              this.$store.dispatch('getModelList'),
              this.$store.dispatch('getBrandList'),
            ];
            await Promise.all(promises);
            blockui.unBlockModal(); */
    },
    onSubmit(e) {
      const self = this;
      const form = window.$(e.target);
      if (form.valid()) {
        // Id, Name, ProcedureTypeId query string ile gider; gövdede yalnız dosya olur. BE tarafı
        // [ApiController] olduğu için basit tipleri query'den bağlar, multipart gövdedeki alanları
        // görmez ve "name is required" (400) döner. Yeni ProcedureDialog da aynı sözleşmeyi kullanır.
        const query = {};
        $.map(form.serializeArray(), (item) => {
          if (item.value !== '') query[item.name] = item.value;
        });
        const formData = new FormData();
        if (self.file[0]) {
          formData.append('File', self.file[0]);
        }
        blockui.blockModal(self);
        api.saveProcedure(formData, query).then((response) => {
          if (response.body.IsSuccess) {
            toastr.success(self.translate('save_successfully'));
            $('#procedure_modal').modal('toggle');
            if (self.procedure != undefined) {
              self.reloadDataTable();
            } else {
              self.$store.dispatch('getRelatedProcedureList', self.$router.history.current.name);
              self.$emit('saved');
            }
          } else {
            toastr.error(response.body.Message);
          }
          blockui.unBlockModal();
        }, (error) => {
          blockui.unBlockModal();
        });
      }
    },
    reloadDataTable() {
      Vue.getDatatables();
    },
    onFileChange(e) {
      const { files } = e.currentTarget;
      const fileSize = ((files[0].size / 1024) / 1024).toFixed(4);
      const extension = files[0].name.split('.').pop().toLowerCase();
      if (typeof files[0].name !== 'undefined' && fileSize <= this.maxFileSize && this.acceptedExtensions.includes(extension)) {
        this.file = files;
      } else {
        toastr.error(this.translate('file_is_not_suitable'));
        this.file = {};
        e.target.value = '';
      }
    },
    downloadFile() {
      const self = this; let
        table;
      blockui.blockModal(self);
      api.getFile({ id: this.selectedProcedure.FileId, isContainsData: true }).then((response) => {
        self.downloadBlob(self.base64toBlob(response.body.Data.Base64, response.body.Data.ContentType), response.body.Data.Name);
        blockui.unBlockModal();
      });
    },
    base64toBlob(base64Data, type) {
      type = type || '';
      // Convert the Base64 string back to text.
      const byteString = atob(base64Data);

      // Convert that text into a byte array.
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type });
    },
    downloadBlob(blob, fileName) {
      const a = $("<a style='display: none;'/>");
      const url = window.URL.createObjectURL(blob);
      a.attr('href', url);
      a.attr('download', fileName);
      $('body').append(a);
      a[0].click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    closeModal() {
      $('#procedure_modal').modal('toggle');
    },
  },
  computed: {
    acceptedExtensionsString() {
      let string = '';
      this.acceptedExtensions.forEach((acceptedExtension, index) => {
        if (index == 0) {
          string += acceptedExtension;
        } else {
          string += `, ${acceptedExtension}`;
        }
      });
      return string;
    },
  },
  watch: {
    procedure(e) {
      this.selectedProcedure = e;
    },
    activeTab(e) {
      this.$nextTick(() => {
        Vue.loadAsteriks();
      });
    },
  },
};
